/* marquee  */
(function(factory){"use strict";if(typeof define==="function"&&define.amd){define(["jquery"],factory)}else if(typeof exports!=="undefined"){module.exports=factory(require("jquery"))}else{factory(jQuery)}})(function($){$.fn.marquee=function(options){return this.each(function(){var o=$.extend({},$.fn.marquee.defaults,options),$this=$(this),$marqueeWrapper,containerWidth,animationCss,verticalDir,elWidth,loopCount=3,playState="animation-play-state",css3AnimationIsSupported=false,_prefixedEvent=function(element,type,callback){var pfx=["webkit","moz","MS","o",""];for(var p=0;p<pfx.length;p++){if(!pfx[p])type=type.toLowerCase();element.addEventListener(pfx[p]+type,callback,false)}},_objToString=function(obj){var tabjson=[];for(var p in obj){if(obj.hasOwnProperty(p)){tabjson.push(p+":"+obj[p])}}tabjson.push();return"{"+tabjson.join(",")+"}"},_startAnimationWithDelay=function(){$this.timer=setTimeout(animate,o.delayBeforeStart)},methods={pause:function(){if(css3AnimationIsSupported&&o.allowCss3Support){$marqueeWrapper.css(playState,"paused")}else{if($.fn.pause){$marqueeWrapper.pause()}}$this.data("runningStatus","paused");$this.trigger("paused")},resume:function(){if(css3AnimationIsSupported&&o.allowCss3Support){$marqueeWrapper.css(playState,"running")}else{if($.fn.resume){$marqueeWrapper.resume()}}$this.data("runningStatus","resumed");$this.trigger("resumed")},toggle:function(){methods[$this.data("runningStatus")==="resumed"?"pause":"resume"]()},destroy:function(){clearTimeout($this.timer);$this.find("*").addBack().off();$this.html($this.find(".js-marquee:first").html())}};if(typeof options==="string"){if($.isFunction(methods[options])){if(!$marqueeWrapper){$marqueeWrapper=$this.find(".js-marquee-wrapper")}if($this.data("css3AnimationIsSupported")===true){css3AnimationIsSupported=true}methods[options]()}return}var dataAttributes={},attr;$.each(o,function(key){attr=$this.attr("data-"+key);if(typeof attr!=="undefined"){switch(attr){case"true":attr=true;break;case"false":attr=false;break}o[key]=attr}});if(o.speed){o.duration=parseInt($this.width(),10)/o.speed*1e3}verticalDir=o.direction==="up"||o.direction==="down";o.gap=o.duplicated?parseInt(o.gap):0;$this.wrapInner('<div class="js-marquee"></div>');var $el=$this.find(".js-marquee").css({"margin-right":o.gap,float:"left"});if(o.duplicated){$el.clone(true).appendTo($this)}$this.wrapInner('<div style="width:100000px" class="js-marquee-wrapper"></div>');$marqueeWrapper=$this.find(".js-marquee-wrapper");if(verticalDir){var containerHeight=$this.height();$marqueeWrapper.removeAttr("style");$this.height(containerHeight);$this.find(".js-marquee").css({float:"none","margin-bottom":o.gap,"margin-right":0});if(o.duplicated){$this.find(".js-marquee:last").css({"margin-bottom":0})}var elHeight=$this.find(".js-marquee:first").height()+o.gap;if(o.startVisible&&!o.duplicated){o._completeDuration=(parseInt(elHeight,10)+parseInt(containerHeight,10))/parseInt(containerHeight,10)*o.duration;o.duration=parseInt(elHeight,10)/parseInt(containerHeight,10)*o.duration}else{o.duration=(parseInt(elHeight,10)+parseInt(containerHeight,10))/parseInt(containerHeight,10)*o.duration}}else{elWidth=$this.find(".js-marquee:first").width()+o.gap;containerWidth=$this.width();if(o.startVisible&&!o.duplicated){o._completeDuration=(parseInt(elWidth,10)+parseInt(containerWidth,10))/parseInt(containerWidth,10)*o.duration;o.duration=parseInt(elWidth,10)/parseInt(containerWidth,10)*o.duration}else{o.duration=(parseInt(elWidth,10)+parseInt(containerWidth,10))/parseInt(containerWidth,10)*o.duration}}if(o.duplicated){o.duration=o.duration/2}if(o.allowCss3Support){var elm=document.body||document.createElement("div"),animationName="marqueeAnimation-"+Math.floor(Math.random()*1e7),domPrefixes="Webkit Moz O ms Khtml".split(" "),animationString="animation",animationCss3Str="",keyframeString="";if(elm.style.animation!==undefined){keyframeString="@keyframes "+animationName+" ";css3AnimationIsSupported=true}if(css3AnimationIsSupported===false){for(var i=0;i<domPrefixes.length;i++){if(elm.style[domPrefixes[i]+"AnimationName"]!==undefined){var prefix="-"+domPrefixes[i].toLowerCase()+"-";animationString=prefix+animationString;playState=prefix+playState;keyframeString="@"+prefix+"keyframes "+animationName+" ";css3AnimationIsSupported=true;break}}}if(css3AnimationIsSupported){animationCss3Str=animationName+" "+o.duration/1e3+"s "+o.delayBeforeStart/1e3+"s infinite "+o.css3easing;$this.data("css3AnimationIsSupported",true)}}var _rePositionVertically=function(){$marqueeWrapper.css("transform","translateY("+(o.direction==="up"?containerHeight+"px":"-"+elHeight+"px")+")")},_rePositionHorizontally=function(){$marqueeWrapper.css("transform","translateX("+(o.direction==="left"?containerWidth+"px":"-"+elWidth+"px")+")")};if(o.duplicated){if(verticalDir){if(o.startVisible){$marqueeWrapper.css("transform","translateY(0)")}else{$marqueeWrapper.css("transform","translateY("+(o.direction==="up"?containerHeight+"px":"-"+(elHeight*2-o.gap)+"px")+")")}}else{if(o.startVisible){$marqueeWrapper.css("transform","translateX(0)")}else{$marqueeWrapper.css("transform","translateX("+(o.direction==="left"?containerWidth+"px":"-"+(elWidth*2-o.gap)+"px")+")")}}if(!o.startVisible){loopCount=1}}else if(o.startVisible){loopCount=2}else{if(verticalDir){_rePositionVertically()}else{_rePositionHorizontally()}}var animate=function(){if(o.duplicated){if(loopCount===1){o._originalDuration=o.duration;if(verticalDir){o.duration=o.direction==="up"?o.duration+containerHeight/(elHeight/o.duration):o.duration*2}else{o.duration=o.direction==="left"?o.duration+containerWidth/(elWidth/o.duration):o.duration*2}if(animationCss3Str){animationCss3Str=animationName+" "+o.duration/1e3+"s "+o.delayBeforeStart/1e3+"s "+o.css3easing}loopCount++}else if(loopCount===2){o.duration=o._originalDuration;if(animationCss3Str){animationName=animationName+"0";keyframeString=$.trim(keyframeString)+"0 ";animationCss3Str=animationName+" "+o.duration/1e3+"s 0s infinite "+o.css3easing}loopCount++}}if(verticalDir){if(o.duplicated){if(loopCount>2){$marqueeWrapper.css("transform","translateY("+(o.direction==="up"?0:"-"+elHeight+"px")+")")}animationCss={transform:"translateY("+(o.direction==="up"?"-"+elHeight+"px":0)+")"}}else if(o.startVisible){if(loopCount===2){if(animationCss3Str){animationCss3Str=animationName+" "+o.duration/1e3+"s "+o.delayBeforeStart/1e3+"s "+o.css3easing}animationCss={transform:"translateY("+(o.direction==="up"?"-"+elHeight+"px":containerHeight+"px")+")"};loopCount++}else if(loopCount===3){o.duration=o._completeDuration;if(animationCss3Str){animationName=animationName+"0";keyframeString=$.trim(keyframeString)+"0 ";animationCss3Str=animationName+" "+o.duration/1e3+"s 0s infinite "+o.css3easing}_rePositionVertically()}}else{_rePositionVertically();animationCss={transform:"translateY("+(o.direction==="up"?"-"+$marqueeWrapper.height()+"px":containerHeight+"px")+")"}}}else{if(o.duplicated){if(loopCount>2){$marqueeWrapper.css("transform","translateX("+(o.direction==="left"?0:"-"+elWidth+"px")+")")}animationCss={transform:"translateX("+(o.direction==="left"?"-"+elWidth+"px":0)+")"}}else if(o.startVisible){if(loopCount===2){if(animationCss3Str){animationCss3Str=animationName+" "+o.duration/1e3+"s "+o.delayBeforeStart/1e3+"s "+o.css3easing}animationCss={transform:"translateX("+(o.direction==="left"?"-"+elWidth+"px":containerWidth+"px")+")"};loopCount++}else if(loopCount===3){o.duration=o._completeDuration;if(animationCss3Str){animationName=animationName+"0";keyframeString=$.trim(keyframeString)+"0 ";animationCss3Str=animationName+" "+o.duration/1e3+"s 0s infinite "+o.css3easing}_rePositionHorizontally()}}else{_rePositionHorizontally();animationCss={transform:"translateX("+(o.direction==="left"?"-"+elWidth+"px":containerWidth+"px")+")"}}}$this.trigger("beforeStarting");if(css3AnimationIsSupported){$marqueeWrapper.css(animationString,animationCss3Str);var keyframeCss=keyframeString+" { 100%  "+_objToString(animationCss)+"}",$styles=$marqueeWrapper.find("style");if($styles.length!==0){$styles.filter(":last").html(keyframeCss)}else{$("head").append("<style>"+keyframeCss+"</style>")}_prefixedEvent($marqueeWrapper[0],"AnimationIteration",function(){$this.trigger("finished")});_prefixedEvent($marqueeWrapper[0],"AnimationEnd",function(){animate();$this.trigger("finished")})}else{$marqueeWrapper.animate(animationCss,o.duration,o.easing,function(){$this.trigger("finished");if(o.pauseOnCycle){_startAnimationWithDelay()}else{animate()}})}$this.data("runningStatus","resumed")};$this.on("pause",methods.pause);$this.on("resume",methods.resume);if(o.pauseOnHover){$this.on("mouseenter",methods.pause);$this.on("mouseleave",methods.resume)}if(css3AnimationIsSupported&&o.allowCss3Support){animate()}else{_startAnimationWithDelay()}})};$.fn.marquee.defaults={allowCss3Support:true,css3easing:"linear",easing:"linear",delayBeforeStart:1e3,direction:"left",duplicated:false,duration:5e3,speed:0,gap:20,pauseOnCycle:false,pauseOnHover:false,startVisible:false}});
function allSiteMarquee() {
  var widthMarquee = $(window).width();
  if(widthMarquee < 750)
  {
    $('.Index_information_marquee').marquee({
      duration: 20000,
      gap: 0,
      delayBeforeStart: 0,
      direction: 'left',
      duplicated: true,
      startVisible: true
    });
  }
  else
  {
    $('.Index_information_marquee').marquee({
      duration: 55000,
      gap: 0,
      delayBeforeStart: 0,
      direction: 'left',
      duplicated: true,
      startVisible: true
    });
  }
  
  if(widthMarquee < 750)
  {
    $('.Index_icons_texts_marquee').marquee({
      duration: 20000,
      gap: 0,
      delayBeforeStart: 0,
      direction: 'left',
      duplicated: true,
      startVisible: true
    });
  }
  else
  {
    $('.Index_icons_texts_marquee').marquee({
      duration: 55000,
      gap: 0,
      delayBeforeStart: 0,
      direction: 'left',
      duplicated: true,
      startVisible: true
    });
  }
}
allSiteMarquee()
function productTabsInit() {
  $(".Tabs_common_inner_new").click(function() {
      var tab_id = $(this).attr("tab_id");
      if ($(this).hasClass("active") == false) {
          $(this).parents(".Tabs_common_main_new").find(".Tabs_common_inner_new").removeClass("active");
          $(this).parents(".Tabs_common_main_new").find(".tabcontent").css("display", "none");
  
          $(this).addClass("active");
          $(this).parents(".Tabs_common_main_new").find("." + tab_id + "_open").css("display", "block");
      }
  })
}
productTabsInit();
document.addEventListener('product-tabs:init',productTabsInit)

function initAccordion() {
    $(".accordion .question").click(function() {
        if ($(this).parent("li").hasClass("open") == false) {
            $(this).parents(".accordion").find(".answer").slideUp();
            $(this).parents(".accordion").find("li").removeClass("open");

            $(this).next(".answer").slideDown();
            $(this).parent(".accordion li").addClass("open");
        } else {
            $(this).parents(".accordion").find(".answer").slideUp();
            //$(this).parents(".accordion").find(".answer").css("display", "none");
            $(this).parents(".accordion").find("li").removeClass("open");
        }
    })
}
initAccordion();

function play_video_on_hover(){
  $(".play_video_on_hover").hover(function(){
    var URL = $(this).find('video').attr("video_url");
    $(this).find('video').attr("src",URL);
    $(this).find('video').trigger('play');
  }, function() {
    $(this).find('video').trigger('pause');
  })
}
play_video_on_hover()

$('.footer-block__details-content .list-unstyled a').on('click', function(event) {
    var target = $(this).attr('href');
    var hash = target.substring(target.indexOf('#') + 1);
    if (hash) {
        $('html, body').stop().animate({
            scrollTop: $("#" + hash).offset().top - 200
        }, 500);

        if ($("#" + hash).hasClass("open") == false) {
            setTimeout(function() {
                $("#" + hash + " .question").trigger("click");
            }, 700)
        }
    }
});

function mobileMenuHeight() {
  //var announcementBarHeight = $(".Header_announcement_bar_main_new").outerHeight(true) || 0;
  var announcementBarHeight = 0;
  var headerHeight = $(".header-section").outerHeight(true) || 0;
  var totalHeight = announcementBarHeight + headerHeight - 1;
  $(".menu-drawer").css("top", totalHeight + "px");
  $(".menu-drawer__backdrop").css("top", totalHeight + "px");
  $(".menu-drawer").css("height", "calc(100% - "+totalHeight+"px)");
}
// Run once DOM is ready
$(document).ready(function () {
  mobileMenuHeight();
});
$(".Header_drawer_main_new").click(function () {
  mobileMenuHeight();
});
// Recalculate on resize
$(window).on("resize", mobileMenuHeight);

function playAndMuteVideoInit(){
  $(".play_icon_new").click(function(){
    if($(this).hasClass("active") == false)
    {
      // for product page
      $(this).parents(".video_play_list_pause_all").find(".play_icon_new").removeClass("active");
      $(this).parents(".video_play_list_pause_all").find('video').trigger('pause');
      
      $(this).addClass("active");
      var URL = $(this).parents(".video_container").find('video').attr("video_url");
      if($(this).parents(".video_container").find('video').attr("src") == null)
      {
        $(this).parents(".video_container").find('video').attr("src",URL);
      }
      $(this).parents(".video_container").find('video').trigger('play');
    }
    else
    {
      $(this).removeClass("active");
      $(this).parents(".video_container").find('video').trigger('pause');
    }
  })
  $(".mute_video").click(function(){
    $(this).removeClass("active");
    $(this).parents(".video_container").find(".unmute_video").addClass("active");
    $(this).parents(".video_container").find("video").prop("muted",0)
  })
  $(".unmute_video").click(function(){
    $(this).removeClass("active");
    $(this).parents(".video_container").find(".mute_video").addClass("active");
    $(this).parents(".video_container").find("video").prop("muted",1)
  })
  // $(".Index_object_tab_benefits_block_innerdetail_innerlists_new .tablinks").click(function() {
  //   $(this).parents(".video_play_list").find(".unmute_video").removeClass("active");
  //   $(this).parents(".video_play_list").find(".mute_video").addClass("active");
  //   $(this).parents(".video_play_list").find("video").prop("muted",1)

  //   $(this).parents(".video_play_list").find(".play_icon_new").addClass("active");
  //   $(this).parents(".video_play_list").find('video').trigger('play');
  // })
  // $(".Product_object_meta_tabs_block_innerlists_new .tablinks").click(function() {
  //   $(this).parents(".video_play_list").find(".unmute_video").removeClass("active");
  //   $(this).parents(".video_play_list").find(".mute_video").addClass("active");
  //   $(this).parents(".video_play_list").find('video').prop("muted",1)
  // })

  $(".Index_object_tab_benefits_block_innerdesktop_innersides_innerright_new .accordion > ul > li").click(function() {
    $(this).parents(".video_play_list").find(".unmute_video").removeClass("active");
    $(this).parents(".video_play_list").find(".mute_video").addClass("active");
    $(this).parents(".video_play_list").find("video").prop("muted",1)

    $(this).parents(".video_play_list").find(".play_icon_new").addClass("active");
    $(this).parents(".video_play_list").find('video').trigger('play');

    var video_box_id = $(this).attr("video_box_id");
    if ($(this).hasClass("open") == true) {
        $(this).parents(".Index_object_tab_benefits_block_innerdesktop_mainsides_new").find(".Index_object_tab_benefits_block_innerdesktop_innersides_innerleft_mainmedia_new ").css("display", "none");
        $(this).parents(".Index_object_tab_benefits_block_innerdesktop_mainsides_new").find("." + video_box_id + "_open").fadeIn();
        $(this).parents(".Index_object_tab_benefits_block_innerdesktop_mainsides_new").find("." + video_box_id + "_open").find(".play_icon_new").click();
        $(this).parents(".Index_object_tab_benefits_block_innerdesktop_mainsides_new").find("." + video_box_id + "_open").find(".play_icon_new").click();
    }
  })
}
playAndMuteVideoInit();
document.addEventListener('play-and-mute-video:init', playAndMuteVideoInit)


function productPageScript() {
  $(".open_ingredients_popup").click(function(){
    $(".overlay_background").addClass("open");
    $(".Product_object_meta_tabs_block_innerblock_innerparts_innerboths_popup_content_new").css("display","block");
  })
  $(".close_ingredients_popup, .overlay_background").click(function(){
    $(".overlay_background").removeClass("open");
    $(".Product_object_meta_tabs_block_innerblock_innerparts_innerboths_popup_content_new").css("display","none");
  })

  if($(".Product_information_new").length > 0)
  {
    var stickyHeaderTopSticky = $(".Product_information_new").offset().top +  $(".Product_information_new").outerHeight(true) - $(".header").outerHeight(true);
    $(window).scroll(function(){
    
      if( $(window).scrollTop() > stickyHeaderTopSticky ) {
          if($('body').hasClass("sticky_header_new") == false)
          {
              $('body').addClass("hide_atc_button_new");
              setTimeout(function(){
                $('body').addClass("delay_sticky_header_new");
              }, 100);
              setTimeout(function(){
                $('body').addClass('sticky_header_new');
              }, 400);
          }
      } else {
          if ($('body').hasClass("sticky_header_new")) {
            $('body').removeClass("sticky_header_new");
            setTimeout(function(){
              $('body').removeClass("hide_atc_button_new");
              $("body").removeClass("delay_sticky_header_new");  
            }, 400);
          }
      }
    });
  }
}
productPageScript()
document.addEventListener('product-page-script:init',productPageScript)

function sliderWidth() {
  var windowWidth = $(window).width();
  console.log(windowWidth);
  var windowWidthFinal = windowWidth - 200;
  if(windowWidth > 1439){
    if(windowWidthFinal < 1704)
    {
      $(".Index_common_slider_new").css("max-width", windowWidthFinal+"px");
    }
    else
    {
      $(".Index_common_slider_new").css("max-width", "");
    }
  }
  else
  {
    $(".Index_common_slider_new").css("max-width", "");
  }
}
// Run once DOM is ready
$(document).ready(function () {
  sliderWidth();
});
// Recalculate on resize
$(window).on("resize", sliderWidth);

/* Header_besties_rewards_slider */
new Swiper('.Header_besties_rewards_slider', {
  loop: true,
  grabCursor: true,
  spaceBetween: 0,
  slidesPerView: 1,
  watchSlidesProgress: true,
  draggable:!0,
  autoHeight:!1,
  watchOverflow:!0,
  threshold:10,
  mousewheel:{
    forceToAxis:!0
  },
  freeMode:!0,
  effect: "fade",
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  }
})

/* Header_announcement_bar_slider */
new Swiper('.Header_announcement_bar_slider', {
  loop: true,
  grabCursor: false,
  spaceBetween: 0,
  slidesPerView: 1,
  watchSlidesProgress: true,
  draggable:!0,
  autoHeight:!1,
  watchOverflow:!0,
  threshold:10,
  mousewheel:{
    forceToAxis:!0
  },
  freeMode:!0,
  effect: "fade",
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  }
})


/* Index_tab_feature_collect_slider */
new Swiper('.Index_tab_feature_collect_slider', {
  loop: false,
  grabCursor: false,
  spaceBetween: 32,
  slidesPerGroup: 1,
  slidesPerView: "auto",
  watchSlidesProgress: true,
  draggable: !0,
  autoHeight: !1,
  watchOverflow: !0,
  threshold: 10,
  mousewheel: {
      forceToAxis: !0
  },
  freeMode: !0,
  observer: true,
  observeParents: true,
  breakpoints: {
    0: {
      spaceBetween: 16,
      freeMode: !1
    },
    750: {
      spaceBetween: 16
    },
    990: {
      spaceBetween: 16
    },
    1200: {
      spaceBetween: 16
    },
    1440: {
      spaceBetween: 32
    }
  }
})

function initRecentlyViewedSlider() {
  if (document.querySelector('.Product_recently_slider')) {
    new Swiper('.Product_recently_slider', {
      loop: false,
      grabCursor: false,
      spaceBetween: 32,
      slidesPerGroup: 1,
      slidesPerView: "auto",
      watchSlidesProgress: true,
      draggable: true,
      autoHeight: false,
      watchOverflow: true,
      threshold: 10,
      mousewheel: {
        forceToAxis: true
      },
      freeMode: true,
      observer: true,
      observeParents: true,
      breakpoints: {
        0: {
          spaceBetween: 16,
          freeMode: false
        },
        750: { spaceBetween: 16 },
        990: { spaceBetween: 16 },
        1200: { spaceBetween: 16 },
        1440: { spaceBetween: 32 }
      }
    });
    play_video_on_hover()
  }
}
// Example: after AJAX success / Liquid render
document.addEventListener("recentlyViewedLoaded", initRecentlyViewedSlider);

/* Index_object_instagram_slider */
new Swiper('.Index_object_instagram_slider', {
  loop: true,
  grabCursor: false,
  spaceBetween: 16,
  slidesPerGroup: 1,
  slidesPerView: "auto",
  watchSlidesProgress: true,
  draggable: !0,
  autoHeight: !1,
  watchOverflow: !0,
  threshold: 10,
  mousewheel: {
      forceToAxis: !0
  },
  freeMode: !0,
  autoplay: {
    delay: 0,
  },
  speed: 4000,
})




/* Index_object_top_brands_slider */
new Swiper('.Index_object_top_brands_slider', {
  loop: false,
  grabCursor: false,
  spaceBetween: 16,
  slidesPerGroup: 1,
  slidesPerView: "auto",
  watchSlidesProgress: true,
  draggable: !0,
  autoHeight: !1,
  watchOverflow: !0,
  threshold: 10,
  mousewheel: {
      forceToAxis: !0
  },
  freeMode: !0,
  observer: true,
  observeParents: true,
  breakpoints: {
    0: {
      spaceBetween: 0,
      freeMode: !1
    },
    750: {
      spaceBetween: 16
    },
    990: {
    },
    1200: {
    },
    1440: {
    }
  }
})

/* Index_banner_block_slider */
/*new Swiper('.Index_banner_block_slider', {
  loop: true,
  grabCursor: true,
  spaceBetween: 24,
  loopedSlides: 3,            // number of duplicated slides
  slidesPerGroup: 1,
  slidesPerView: 1.09032,
  //slidesPerView: 1,
  watchSlidesProgress: true,
  draggable: !0,
  autoHeight: !1,
  watchOverflow: !0,
  threshold: 10,
  //centeredSlides: true,
  centeredSlides: false,
  mousewheel: {
      forceToAxis: !0
  },
  speed:700,
  autoplay: {
    delay: 10000,
    // disableOnInteraction: false,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    0: {
      spaceBetween: 8
    },
    750: {
      spaceBetween: 10,
    },
    990: {
      spaceBetween: 10,
    },
    1200: {
      spaceBetween: 10,
    },
    1440: {
      spaceBetween: 24,
    }
  }
})*/



/* Index_object_testimonials_slider */
new Swiper('.Index_object_testimonials_slider', {
  loop: false,
  grabCursor: false,
  spaceBetween: 32,
  slidesPerGroup: 1,
  slidesPerView: "auto",
  watchSlidesProgress: true,
  draggable: !0,
  autoHeight: !1,
  watchOverflow: !0,
  threshold: 10,
  mousewheel: {
      forceToAxis: !0
  },
  freeMode: !0,
  observer: true,
  observeParents: true,
  breakpoints: {
    0: {
      spaceBetween: 16,
      freeMode: !1
    },
    750: {
      spaceBetween: 16
    },
    990: {
      spaceBetween: 24
    },
    1200: {
      spaceBetween: 32
    },
    1440: {
    }
  }
})

/* For 1 slider Start */
/* ==================================================
   COMMON HELPERS
================================================== */
function pauseVideosInside(container) {
  if (!container) return;

  container.querySelectorAll("video").forEach(v => v.pause());
  container.querySelectorAll(".play_icon_new").forEach(i => i.classList.remove("active"));
}

/* ==================================================
   ============ SLIDER SET 1 =========================
================================================== */

/* THUMBS 1 */
var swiperThumbs = new Swiper(".Index_object_tab_benefits_mobile_content_slider_1", {
  loop: true,
  grabCursor: true,
  spaceBetween: 16,
  slidesPerView: "auto",
  watchSlidesProgress: true,
  slideToClickedSlide: true,
  speed: 500
});

/* MAIN 1 */
var swiperMain = new Swiper(".Index_object_tab_benefits_mobile_media_slider_1", {
  loop: true,
  grabCursor: true,
  spaceBetween: 16,
  slidesPerView: "auto",
  speed: 500,
  centeredSlides: false,
  centeredSlidesBounds: true,
  thumbs: { swiper: swiperThumbs }
});

/* INFO 1 */
var swiperInfo = new Swiper(".Index_object_tab_benefits_mobile_info_slider_1", {
  loop: true,
  grabCursor: true,
  slidesPerView: 1,
  speed: 500
});

/* VIDEO PLAY 1 */
function playActiveSlideVideo() {
  if (window.innerWidth >= 750) return;

  const wrapper = document.querySelector(".Index_object_tab_benefits_mobile_media_slider_1");
  if (!wrapper) return;

  pauseVideosInside(wrapper);

  const slide = swiperMain.slides[swiperMain.activeIndex];
  if (!slide) return;

  const btn = slide.querySelector(".play_icon_new");
  if (btn) requestAnimationFrame(() => btn.click());
}

/* SYNC 1 */
swiperMain.on("slideChangeTransitionEnd", function () {
  swiperInfo.slideToLoop(swiperMain.realIndex, 300);
  playActiveSlideVideo();

  if (window.innerWidth < 750) {
    swiperMain.slides.forEach(slide => {
      const v = slide.querySelector("video");
      if (v) v.muted = true;
    });
  }
});

swiperInfo.on("slideChangeTransitionEnd", function () {
  swiperMain.slideToLoop(swiperInfo.realIndex, 300);
});

/* DESKTOP FIRST VIDEO 1 */
$(document).ready(function () {
  if ($(window).width() >= 750) {
    $(".Index_object_tab_benefits_block_innerdesktop_innersides_innerleft_mainmedia_new")
      .first()
      .find(".play_icon_new")
      .trigger("click");
  }
});

/* ==================================================
   ============ SLIDER SET 2 =========================
================================================== */

/* THUMBS 2 */
var swiperThumbs_2 = new Swiper(".Index_object_tab_benefits_mobile_content_slider_2", {
  loop: true,
  grabCursor: true,
  spaceBetween: 16,
  slidesPerView: "auto",
  watchSlidesProgress: true,
  slideToClickedSlide: true,
  speed: 500
});

/* MAIN 2 */
var swiperMain_2 = new Swiper(".Index_object_tab_benefits_mobile_media_slider_2", {
  loop: true,
  grabCursor: true,
  spaceBetween: 16,
  slidesPerView: "auto",
  speed: 500,
  centeredSlides: false,
  centeredSlidesBounds: true,
  thumbs: { swiper: swiperThumbs_2 }
});

/* INFO 2 */
var swiperInfo_2 = new Swiper(".Index_object_tab_benefits_mobile_info_slider_2", {
  loop: true,
  grabCursor: true,
  slidesPerView: 1,
  speed: 500
});

/* VIDEO PLAY 2 */
function playActiveSlideVideo_2() {
  if (window.innerWidth >= 750) return;

  const wrapper = document.querySelector(".Index_object_tab_benefits_mobile_media_slider_2");
  if (!wrapper) return;

  pauseVideosInside(wrapper);

  const slide = swiperMain_2.slides[swiperMain_2.activeIndex];
  if (!slide) return;

  const btn = slide.querySelector(".play_icon_new");
  if (btn) requestAnimationFrame(() => btn.click());
}

/* SYNC 2 */
swiperMain_2.on("slideChangeTransitionEnd", function () {
  swiperInfo_2.slideToLoop(swiperMain_2.realIndex, 300);
  playActiveSlideVideo_2();

  if (window.innerWidth < 750) {
    swiperMain_2.slides.forEach(slide => {
      const v = slide.querySelector("video");
      if (v) v.muted = true;
    });
  }
});

swiperInfo_2.on("slideChangeTransitionEnd", function () {
  swiperMain_2.slideToLoop(swiperInfo_2.realIndex, 300);
});

/* DESKTOP FIRST VIDEO 2 */
$(document).ready(function () {
  if ($(window).width() >= 750) {
    $(".Index_object_tab_benefits_block_innerdesktop_innersides_innerleft_mainmedia_new_2")
      .first()
      .find(".play_icon_new")
      .trigger("click");
  }
});

/* ==================================================
   TAB SWITCH FIX (🔥 MOST IMPORTANT)
================================================== */
function onTabChangeFix() {
  setTimeout(() => {
    swiperMain.update();
    swiperThumbs.update();
    swiperInfo.update();

    swiperMain_2.update();
    swiperThumbs_2.update();
    swiperInfo_2.update();

    if (window.innerWidth < 750) {
      playActiveSlideVideo();
      playActiveSlideVideo_2();
    }
  }, 120);
}

$(document).on("click", ".Index_object_tab_benefits_block_innerdetail_innerlists_new .tablinks", function () {
  onTabChangeFix();
});

/* ==================================================
   PAGE LOAD → MOBILE FIRST VIDEO
================================================== */
setTimeout(function () {
  if (window.innerWidth < 750) {
    playActiveSlideVideo();
    playActiveSlideVideo_2();
  }
}, 600);




/* For 2 slider End */

function productTabsSliderInit(){
  /* Product_object_meta_tabs_media_slider */
  new Swiper('.Product_object_meta_tabs_media_slider', {
    loop: false,
    grabCursor: false,
    spaceBetween: 16,
    slidesPerGroup: 1,
    slidesPerView: "auto",
    watchSlidesProgress: true,
    draggable: !0,
    autoHeight: !1,
    watchOverflow: !0,
    threshold: 10,
    mousewheel: {
        forceToAxis: !0
    },
    freeMode: !0,
    observer: true,
    observeParents: true
  })
}
productTabsSliderInit();
document.addEventListener('product-tab-slider:init', productTabsSliderInit)


/* Header_megamenu_custom_detail_slider */
new Swiper('.Header_megamenu_custom_detail_slider', {
  loop: false,
  grabCursor: true,
  spaceBetween: 16,
  slidesPerGroup: 1,
  slidesPerView: "auto",
  watchSlidesProgress: true,
  draggable: !0,
  autoHeight: !1,
  watchOverflow: !0,
  threshold: 10,
  mousewheel: {
      forceToAxis: !0
  },
  freeMode: !0,
  observer: true,
  observeParents: true,
  breakpoints: {
    0: {
      spaceBetween: 8,
      freeMode: !1
    },
    750: {
      spaceBetween: 16
    },
    990: {
    },
    1200: {
    },
    1440: {
    }
  }
})


/* Header_megamenu_lists_texts_slider */
new Swiper('.Header_megamenu_lists_texts_slider', {
  loop: false,
  grabCursor: true,
  spaceBetween: 12,
  slidesPerGroup: 1,
  slidesPerView: "auto",
  watchSlidesProgress: true,
  draggable: !0,
  autoHeight: !1,
  watchOverflow: !0,
  threshold: 10,
  mousewheel: {
      forceToAxis: !0
  },
  freeMode: !0,
  observer: true,
  observeParents: true
})


/* Header_megamenu_custom_single_slider */
new Swiper('.Header_megamenu_custom_single_slider', {
  loop: false,
  grabCursor: true,
  spaceBetween: 8,
  slidesPerGroup: 1,
  slidesPerView: 1,
  watchSlidesProgress: true,
  draggable: !0,
  autoHeight: !1,
  watchOverflow: !0,
  threshold: 10,
  mousewheel: {
      forceToAxis: !0
  },
  observer: true,
  observeParents: true
})


/* Header_megamenu_custom_three_slider */
new Swiper('.Header_megamenu_custom_three_slider', {
  loop: false,
  grabCursor: true,
  spaceBetween: 16,
  slidesPerGroup: 1,
  slidesPerView: 3,
  watchSlidesProgress: true,
  draggable: !0,
  autoHeight: !1,
  watchOverflow: !0,
  threshold: 10,
  mousewheel: {
      forceToAxis: !0
  },
  freeMode: !0,
  observer: true,
  observeParents: true
})

/* Header_megamenu_custom_two_slider */
new Swiper('.Header_megamenu_custom_two_slider', {
  loop: false,
  grabCursor: true,
  spaceBetween: 16,
  slidesPerGroup: 1,
  slidesPerView: 2,
  watchSlidesProgress: true,
  draggable: !0,
  autoHeight: !1,
  watchOverflow: !0,
  threshold: 10,
  mousewheel: {
      forceToAxis: !0
  },
  freeMode: !0,
  observer: true,
  observeParents: true
})

function collectionFilter() {
  var $el = $('.Collection_template_mainright_new');
  if ($el.length > 0) {
    var stickyHeaderTop = $(".Collection_template_mainright_new").offset().top
    
    //console.log(stickyHeaderTop);
    // passing "true" will also include the top and bottom margin
    $(window).scroll(function () {
        if ($(window).scrollTop() > stickyHeaderTop) {
            if ($('body').hasClass("collection_fixed") == false) {
                $('body').addClass('collection_fixed');
            }
        } else {
            $('body').removeClass('collection_fixed');

            /*$(".Collection_filter_new").css("height","");
            $(".Collection_filter_new").css("top","");

            $("body.collection_fixed:has([data-scroll-direction=up]) .Collection_filter_new").css("height","");
            $("body.collection_fixed:has([data-scroll-direction=up]) .Collection_filter_new").css("top","");*/
        }
    });
  }
  var pageHeight = $(window).height();
  var headerHeight = $(".header").outerHeight(true);
  var finalHeight = pageHeight - headerHeight;

  /*$(".collection_fixed .Collection_filter_new").height(pageHeight+"px");
  $(".collection_fixed .Collection_filter_new").css("top","0px");

  $("body.collection_fixed:has([data-scroll-direction=up]) .Collection_filter_new").css("height", finalHeight + "px");
  $("body.collection_fixed:has([data-scroll-direction=up]) .Collection_filter_new").css("top", headerHeight + "px");*/

  /* Filter Slider width Setup */
  var desktop_filter_result_main_new = $(".desktop_filter_result_main_new").outerWidth(true);
  var sorting_filter = $(".sorting_new").outerWidth(true);
  var resultWidth = desktop_filter_result_main_new - sorting_filter;
  $(".desktop_filter_result_new").css("width",resultWidth+"px");

  /* Back to Top */
  var $el_2 = $('.Collection_template_mainright_new');
  if ($el_2.length > 0) {
    var stickyHeaderTop_2 = ($(window).height()) * 2;
    
    //console.log(stickyHeaderTop);
    // passing "true" will also include the top and bottom margin
    $(window).scroll(function () {
        if ($(window).scrollTop() > stickyHeaderTop_2) {
            if ($('body').hasClass("back_to_top") == false) {
                $('body').addClass('back_to_top');
            }
        } else {
            $('body').removeClass('back_to_top');
        }
    });
  }

}
collectionFilter()
$(window).resize(function(){
  collectionFilter();
});
$(window).scroll(function(){
  collectionFilter();
});

function collectionFilterResultSliderInit () {
  /* Collection_filter_result_slider */
  new Swiper('.Collection_filter_result_slider', {
    loop: false,
    grabCursor: false,
    spaceBetween: 8,
    slidesPerGroup: 1,
    slidesPerView: "auto",
    watchSlidesProgress: true,
    draggable: !0,
    autoHeight: !1,
    watchOverflow: !0,
    threshold: 10,
    mousewheel: {
        forceToAxis: !0
    },
    freeMode: !0,
    observer: true,
    observeParents: true
  })

  }
collectionFilterResultSliderInit();
document.addEventListener('collection-filter-result-slider:init', collectionFilterResultSliderInit)



/*!
* Optiscroll.js 
*/
!function(E,y,C,o){"use strict";var i=function t(e,i){return new t.Instance(e,i||{})},c=i.globalSettings={scrollMinUpdateInterval:25,checkFrequency:1e3,pauseCheck:!1};i.defaults={preventParentScroll:!1,forceScrollbars:!1,scrollStopDelay:300,maxTrackSize:95,minTrackSize:5,draggableTracks:!0,autoUpdate:!0,classPrefix:"optiscroll-",wrapContent:!0,rtl:!1},(i.Instance=function(t,e){this.element=t,this.settings=S(S({},i.defaults),e||{}),"boolean"!=typeof e.rtl&&(this.settings.rtl="rtl"===E.getComputedStyle(t).direction),this.cache={},this.init()}).prototype={init:function(){var t=this.element,e=this.settings,i=!1,l=this.scrollEl=e.wrapContent?u.createWrapper(t):t.firstElementChild;T(l,e.classPrefix+"content",!0),T(t,"is-enabled"+(e.rtl?" is-rtl":""),!0),this.scrollbars={v:s("v",this),h:s("h",this)},(w.scrollbarSpec.width||e.forceScrollbars)&&(i=u.hideNativeScrollbars(l,e.rtl)),i&&h(this.scrollbars,"create"),w.isTouch&&e.preventParentScroll&&T(t,e.classPrefix+"prevent",!0),this.update(),this.bind(),e.autoUpdate&&w.instances.push(this),e.autoUpdate&&!w.checkTimer&&u.checkLoop()},bind:function(){var l,s,n,r,t=this.listeners={},e=this.scrollEl;for(var i in t.scroll=(l=a.scroll.bind(this),s=c.scrollMinUpdateInterval,function(){var t=this,e=Date.now(),i=arguments;n&&e<n+s?(clearTimeout(r),r=setTimeout(function(){n=e,l.apply(t,i)},s)):(n=e,l.apply(t,i))}),w.isTouch&&(t.touchstart=a.touchstart.bind(this),t.touchend=a.touchend.bind(this)),t.mousewheel=t.wheel=a.wheel.bind(this),t)e.addEventListener(i,t[i],w.passiveEvent)},update:function(){var t=this.scrollEl,e=this.cache,i=e.clientH,l=t.scrollHeight,s=t.clientHeight,n=t.scrollWidth,r=t.clientWidth;if(l!==e.scrollH||s!==e.clientH||n!==e.scrollW||r!==e.clientW){if(e.scrollH=l,e.clientH=s,e.scrollW=n,e.clientW=r,i!==o){if(0===l&&0===s&&!y.body.contains(this.element))return this.destroy(),!1;this.fireCustomEvent("sizechange")}h(this.scrollbars,"update")}},scrollTo:function(t,e,i){var l,s,n,r,o=this.cache;w.pauseCheck=!0,this.update(),l=this.scrollEl.scrollLeft,s=this.scrollEl.scrollTop,n=+t,"left"===t&&(n=0),"right"===t&&(n=o.scrollW-o.clientW),!1===t&&(n=l),r=+e,"top"===e&&(r=0),"bottom"===e&&(r=o.scrollH-o.clientH),!1===e&&(r=s),this.animateScroll(l,n,s,r,+i)},scrollIntoView:function(t,e,i){var l,s,n,r,o,c,a,h,u,p,d,f,v=this.scrollEl;w.pauseCheck=!0,this.update(),"string"==typeof t?t=v.querySelector(t):t.length&&t.jquery&&(t=t[0]),"number"==typeof i&&(i={top:i,right:i,bottom:i,left:i}),i=i||{},l=t.getBoundingClientRect(),s=v.getBoundingClientRect(),u=d=v.scrollLeft,p=f=v.scrollTop,a=u+l.left-s.left,h=p+l.top-s.top,n=a-(i.left||0),r=h-(i.top||0),n<u&&(d=n),u<(o=a+l.width-this.cache.clientW+(i.right||0))&&(d=o),r<p&&(f=r),p<(c=h+l.height-this.cache.clientH+(i.bottom||0))&&(f=c),this.animateScroll(u,d,p,f,+e)},animateScroll:function(l,s,n,r,o){var c=this,a=this.scrollEl,h=Date.now();if(s!==l||r!==n){if(0===o)return a.scrollLeft=s,void(a.scrollTop=r);isNaN(o)&&(o=15*C.pow(C.max(C.abs(s-l),C.abs(r-n)),.54)),function t(){var e=C.min(1,(Date.now()-h)/o),i=u.easingFunction(e);r!==n&&(a.scrollTop=~~(i*(r-n))+n),s!==l&&(a.scrollLeft=~~(i*(s-l))+l),c.scrollAnimation=e<1?E.requestAnimationFrame(t):null}()}},destroy:function(){var t,e=this,i=this.element,l=this.scrollEl,s=this.listeners;if(this.scrollEl){for(var n in s)l.removeEventListener(n,s[n]);if(h(this.scrollbars,"remove"),!this.settings.contentElement){for(;t=l.childNodes[0];)i.insertBefore(t,l);i.removeChild(l),this.scrollEl=null}T(i,this.settings.classPrefix+"prevent",!1),T(i,"is-enabled",!1),E.requestAnimationFrame(function(){var t=w.instances.indexOf(e);-1<t&&w.instances.splice(t,1)})}},fireCustomEvent:function(t){var e,i,l=this.cache,s=l.scrollH,n=l.scrollW;e={scrollbarV:S({},l.v),scrollbarH:S({},l.h),scrollTop:l.v.position*s,scrollLeft:l.h.position*n,scrollBottom:(1-l.v.position-l.v.size)*s,scrollRight:(1-l.h.position-l.h.size)*n,scrollWidth:n,scrollHeight:s,clientWidth:l.clientW,clientHeight:l.clientH},"function"==typeof CustomEvent?i=new CustomEvent(t,{detail:e}):(i=y.createEvent("CustomEvent")).initCustomEvent(t,!1,!1,e),this.element.dispatchEvent(i)}};var t,e,a={scroll:function(t){w.pauseCheck||this.fireCustomEvent("scrollstart"),w.pauseCheck=!0,this.scrollbars.v.update(),this.scrollbars.h.update(),this.fireCustomEvent("scroll"),clearTimeout(this.cache.timerStop),this.cache.timerStop=setTimeout(a.scrollStop.bind(this),this.settings.scrollStopDelay)},touchstart:function(t){w.pauseCheck=!1,this.scrollbars.v.update(),this.scrollbars.h.update(),a.wheel.call(this,t)},touchend:function(t){clearTimeout(this.cache.timerStop)},scrollStop:function(){this.fireCustomEvent("scrollstop"),w.pauseCheck=!1},wheel:function(t){var e=this.cache,i=e.v,l=e.h,s=this.settings.preventParentScroll&&w.isTouch;E.cancelAnimationFrame(this.scrollAnimation),s&&i.enabled&&i.percent%100==0&&(this.scrollEl.scrollTop=i.percent?e.scrollH-e.clientH-1:1),s&&l.enabled&&l.percent%100==0&&(this.scrollEl.scrollLeft=l.percent?e.scrollW-e.clientW-1:1)}},s=function(e,i){var r="v"===e,l=i.element,o=i.scrollEl,c=i.settings,a=i.cache,n=a[e]={},t=r?"H":"W",h="client"+t,u="scroll"+t,p=r?"scrollTop":"scrollLeft",s=r?["top","bottom"]:["left","right"],d=/^(mouse|touch|pointer)/,f=w.scrollbarSpec.rtl,v=!1,m=null,g=null,b={dragData:null,dragStart:function(t){t.preventDefault();var e=t.touches?t.touches[0]:t;b.dragData={x:e.pageX,y:e.pageY,scroll:o[p]},b.bind(!0,t.type.match(d)[1])},dragMove:function(t){var e,i=t.touches?t.touches[0]:t,l=c.rtl&&1===f&&!r?-1:1;t.preventDefault(),e=(r?i.pageY-b.dragData.y:i.pageX-b.dragData.x)/a[h],o[p]=b.dragData.scroll+e*a[u]*l},dragEnd:function(t){b.dragData=null,b.bind(!1,t.type.match(d)[1])},bind:function(t,e){var i=(t?"add":"remove")+"EventListener",l=e+"move",s=e+("touch"===e?"end":"up");y[i](l,b.dragMove),y[i](s,b.dragEnd),y[i](e+"cancel",b.dragEnd)}};return{toggle:function(t){v=t,g&&T(l,"has-"+e+"track",v),n.enabled=v},create:function(){(m=y.createElement("div"),g=y.createElement("b"),m.className=c.classPrefix+e,g.className=c.classPrefix+e+"track",m.appendChild(g),l.appendChild(m),c.draggableTracks)&&(E.PointerEvent?["pointerdown"]:["touchstart","mousedown"]).forEach(function(t){g.addEventListener(t,b.dragStart)})},update:function(){var t,e,i,l,s;(v||a[h]!==a[u])&&(t=(i=this.calc()).size,e=n.size,l=1/t*i.position*100,s=C.abs(i.position-(n.position||0))*a[h],1===t&&v&&this.toggle(!1),t<1&&!v&&this.toggle(!0),g&&v&&this.style(l,s,t,e),n=S(n,i),v&&this.fireEdgeEv())},style:function(t,e,i,l){i!==l&&(g.style[r?"height":"width"]=100*i+"%",c.rtl&&!r&&(g.style.marginRight=100*(1-i)+"%")),g.style[w.cssTransform]="translate("+(r?"0%,"+t+"%":t+"%,0%")+")"},calc:function(){var t,e=o[p],i=a[h],l=a[u],s=i/l,n=l-i;return 1<=s||!l?{position:0,size:1,percent:0}:(!r&&c.rtl&&f&&(e=n-e*f),t=100*e/n,e<=1&&(t=0),n-1<=e&&(t=100),s=C.max(s,c.minTrackSize/100),{position:t/100*(1-(s=C.min(s,c.maxTrackSize/100))),size:s,percent:t})},fireEdgeEv:function(){var t=n.percent;n.was!==t&&t%100==0&&(i.fireCustomEvent("scrollreachedge"),i.fireCustomEvent("scrollreach"+s[t/100])),n.was=t},remove:function(){this.toggle(!1),m&&(m.parentNode.removeChild(m),m=null)}}},u={hideNativeScrollbars:function(t,e){var i=w.scrollbarSpec.width,l=t.style;if(0===i){var s=Date.now();return t.setAttribute("data-scroll",s),u.addCssRule('[data-scroll="'+s+'"]::-webkit-scrollbar',"display:none;width:0;height:0;")}return l[e?"left":"right"]=-i+"px",l.bottom=-i+"px",!0},addCssRule:function(t,e){var i=y.getElementById("scroll-sheet");i||((i=y.createElement("style")).id="scroll-sheet",i.appendChild(y.createTextNode("")),y.head.appendChild(i));try{return i.sheet.insertRule(t+" {"+e+"}",0),!0}catch(t){return}},createWrapper:function(t,e){for(var i,l=y.createElement("div");i=t.childNodes[0];)l.appendChild(i);return t.appendChild(l)},checkLoop:function(){w.instances.length?(w.pauseCheck||h(w.instances,"update"),c.checkFrequency&&(w.checkTimer=setTimeout(function(){u.checkLoop()},c.checkFrequency))):w.checkTimer=null},easingFunction:function(t){return--t*t*t+1}},w=i.G={isTouch:"ontouchstart"in E,cssTransition:l("transition"),cssTransform:l("transform"),scrollbarSpec:function(){var t,e,i=y.documentElement,l=0,s=1;(t=y.createElement("div")).style.cssText="overflow:scroll;width:50px;height:50px;position:absolute;left:-100px;direction:rtl",(e=y.createElement("div")).style.cssText="width:100px;height:100px",t.appendChild(e),i.appendChild(t),l=t.offsetWidth-t.clientWidth,0<t.scrollLeft?s=0:(t.scrollLeft=1,0===t.scrollLeft&&(s=-1));return i.removeChild(t),{width:l,rtl:s}}(),passiveEvent:(t=!1,e=Object.defineProperty({},"passive",{get:function(){t=!0}}),E.addEventListener("test",null,e),!!t&&{capture:!1,passive:!0}),instances:[],checkTimer:null,pauseCheck:!1};function l(t){var e=t.charAt(0).toUpperCase()+t.slice(1),i=y.createElement("test"),l=[t,"Webkit"+e];for(var s in l)if(i.style[l[s]]!==o)return l[s];return""}function T(t,e,i){var l=t.className.split(/\s+/),s=l.indexOf(e);i?~s||l.push(e):~s&&l.splice(s,1),t.className=l.join(" ")}function S(t,e,i){for(var l in e)!e.hasOwnProperty(l)||t[l]!==o&&i||(t[l]=e[l]);return t}function h(t,e,i){var l,s;if(t.length)for(l=0,s=t.length;l<s;l++)t[l][e].apply(t[l],i);else for(l in t)t[l][e].apply(t[l],i)}"function"==typeof define&&define.amd&&define(function(){return i}),"undefined"!=typeof module&&module.exports&&(module.exports=i),E.Optiscroll=i}(window,document,Math),function(n){var r="optiscroll";n.fn[r]=function(i){var l,s;return"string"==typeof i&&(s=Array.prototype.slice.call(arguments),l=s.shift()),this.each(function(){var t=n(this),e=t.data(r);e?e&&"string"==typeof l&&(e[l].apply(e,s),"destroy"===l&&t.removeData(r)):(e=new window.Optiscroll(this,i||{}),t.data(r,e))})}}(jQuery||Zepto);
// $(".optiscroll").optiscroll({ forceScrollbars: true })


function quickAtcSlider(){
  if(window.innerWidth > 767){
    let swiperInstance;
      function initSwiper() {
        if (window.innerWidth >= 991) {  
          if (!swiperInstance) {
            swiperInstance = new Swiper("[hb-text-icon-swiper-container]", {
              slidesPerView: "auto",  
              spaceBetween: 40,   
            });
          }
        } else { 
          if (swiperInstance) {
            swiperInstance.destroy(true, true);
            swiperInstance = null;
          }
        }
      }
      initSwiper();
      window.addEventListener("resize", initSwiper);
  }
}
quickAtcSlider()
document.addEventListener('quick-atc-slider:init' , quickAtcSlider);


document.addEventListener('DOMContentLoaded', function() {
  const chatBtn = document.getElementById('open-gorgias-chat');

  if(chatBtn) {
    function waitForGorgias(retries = 50, interval = 200) {
      if (window.GorgiasChat && typeof window.GorgiasChat.init === "function") {
        // Chat script loaded, bind click
        window.GorgiasChat.init().then(() => {
          chatBtn.addEventListener('click', function() {
            if (window.GorgiasChat.isOpen && window.GorgiasChat.isOpen()) {
            window.GorgiasChat.close();
            } else {
              window.GorgiasChat.open();
            }
          });
          console.log('Gorgias chat button bound.');
        });
      } else if (retries > 0) {
        // Retry after interval
        setTimeout(() => waitForGorgias(retries - 1, interval), interval);
      } else {
        console.warn('GorgiasChat.init() not found after waiting.');
      }
    }
  
    waitForGorgias(); // Start polling
  }
});

document.addEventListener('DOMContentLoaded', function () {
  
  const tabButtons = document.querySelectorAll('[data-pf-type="TabHeader2"]');
  const tabContents = document.querySelectorAll('[data-pf-type="TabsContent"]');

  tabButtons.forEach((button, index) => {
    button.addEventListener('click', () => {
      
      tabButtons.forEach(btn => btn.setAttribute('data-pf-tab-active', 'false'));
      
      button.setAttribute('data-pf-tab-active', 'true');

      
      tabContents.forEach(content => content.style.display = 'none');
      
      if (tabContents[index]) {
        tabContents[index].style.display = 'block';
      }
    });
  });
});
